import React from "react";

import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

function NavMenuItem({ onClick, Icon, page, to }) {
	return (
		<MenuItem onClick={onClick}>
			<ListItemIcon>{Icon}</ListItemIcon>
			<Typography textAlign="center">
				<Link
					to={to}
					className="text-decoration-none text-dark"
				>
					{page}
				</Link>
			</Typography>
		</MenuItem>
	);
}

export default NavMenuItem;
